import crypto from "crypto";
export function decrypt(text) {
  const encryption_key = "byz9VFNtbRQM0yBODcCb1lrUtVVH3D3x"; // Must be 32 characters

  const initialization_vector = "X05IGQ5qdBnIqAWD"; // Must be 16 characters

  const decipher = crypto.createDecipheriv("aes-256-cbc", Buffer.from(encryption_key), Buffer.from(initialization_vector));
  let dec = decipher.update(text, "hex", "utf8");
  dec += decipher.final("utf8");
  return dec;
}
export function allowedRole(user, roles) {
  const userData = decryptSession(user);
  return userData && userData.role ? roles.includes(userData.role) : false;
}
export function decryptSession(userSession) {
  if (userSession) {
    if (typeof userSession.session === "string") {
      return JSON.parse(decrypt(userSession.session));
    }
  }

  return undefined;
}
export function checkRoles(user, roles) {
  return user && user.role ? roles.includes(user.role) : false;
}